import { R7E_AuthorApplication, R7eAccountTypeError, r7eBaseApp } from './r7e';

const new_r7eApplication = () => {
    return new R7E_AuthorApplication(r7eBaseApp);
}

import { inject } from 'vue'
const getR7eApp = () => {
    const r7eApp = inject('r7eApp');
    return r7eApp;
}

// const r7eApp = new R7E_AuthorApplication(r7eBaseApp);

export {R7eAccountTypeError, R7E_AuthorApplication, new_r7eApplication, getR7eApp };
export default {...R7eAccountTypeError, R7E_AuthorApplication, new_r7eApplication, getR7eApp }
